'use strict';

module.exports = {
    ELECTRON_MASS: 5.48579909070e-4
};



// WEBPACK FOOTER //
// ../chemical-elements/src/constants.js